import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CheckinAcceptanceResultEffect } from './checkin-acceptance-result.effect';
import { checkinAcceptanceResultReducer } from './checkin-acceptance-result.reducer';
import { CHECKIN_ACCEPTANCE_RESULT_STORE_NAME, CheckinAcceptanceResultState } from './checkin-acceptance-result.state';

/** Token of the CheckinAcceptanceResult reducer */
export const CHECKIN_ACCEPTANCE_RESULT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<CheckinAcceptanceResultState, Action>
>('Feature CheckinAcceptanceResult Reducer');

/** Provide default reducer for CheckinAcceptanceResult store */
export function getDefaultCheckinAcceptanceResultReducer() {
  return checkinAcceptanceResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(CHECKIN_ACCEPTANCE_RESULT_STORE_NAME, CHECKIN_ACCEPTANCE_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([CheckinAcceptanceResultEffect]),
  ],
  providers: [
    { provide: CHECKIN_ACCEPTANCE_RESULT_REDUCER_TOKEN, useFactory: getDefaultCheckinAcceptanceResultReducer },
  ],
})
export class CheckinAcceptanceResultStoreModule {
  public static forRoot<T extends CheckinAcceptanceResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<CheckinAcceptanceResultStoreModule> {
    return {
      ngModule: CheckinAcceptanceResultStoreModule,
      providers: [{ provide: CHECKIN_ACCEPTANCE_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
